'use strict'

import axios from "axios"
import qs from 'qs'

import  {getCookie} from  './common'

axios.defaults.timeout = 20000;


//axios.defaults.baseURL='http://api.shenbipro.quba360.com'
axios.defaults.baseURL='https://api.shenbipro.com'
// axios.defaults.withCredentials=true



// 请求前拦截
axios.interceptors.request.use(
    config => {
        let token = getCookie('token');
        token && (config.headers.Authorization = 'Bearer '+token);
        return config;
    },
    error => {
        return Promise.error(error);
    })

axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        const errorString = error.toString()
        if(errorString.includes('timeout')){
            error.message = "Error timeout 408"
        }
        return Promise.reject(error)
    }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params={}){
    return new Promise((resolve, reject) =>{
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err =>{
            reject(err.data)
        })
    });}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */


export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err =>{
                reject(err.data)
            })
    });
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function destroy(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, { data: params })
            .then(res => {
                resolve(res.data);
            })
            .catch(err =>{
                reject(err.data)
            })
    });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */


export function postByFormData(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, {
            headers: {'Content-Type': 'multipart/form-data' }
          })
            .then(res => {
                resolve(res.data);
            })
            .catch(err =>{
                reject(err.data)
            })
    });
}